/* eslint-disable import/prefer-default-export */
import { CHANGE_PAGE_TITLE } from '../actionTypes';

export const setPageTitle = (payload) => async (dispatch) => {
  dispatch({
    type: CHANGE_PAGE_TITLE,
    payload,
  });
};
